import AuthLayout from "@/layout/auth";
import Loader from "@quest/ui/components/loader";
import { lazy, Suspense } from "react";
import { RouteObject } from "react-router-dom";
import ErrorPage from "@quest/shared/error-page";

const FallbackLoader = () => {
  return <Loader />;
};

const LoginPage = lazy(() => import("@/features/auth/pages/login"));
const RegisterPage = lazy(() => import("@/features/auth/pages/register"));
const ForgotPasswordPage = lazy(
  () => import("@/features/auth/pages/forgot-password")
);

export const authRoutes: RouteObject[] = [
  {
    path: "/login",
    element: (
      <Suspense fallback={<FallbackLoader />}>
        <AuthLayout />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
    children: [{ path: "/login", element: <LoginPage /> }],
  },
  {
    path: "/forgot-password",
    element: (
      <Suspense fallback={<FallbackLoader />}>
        <AuthLayout />
      </Suspense>
    ),
    children: [{ path: "/forgot-password", element: <ForgotPasswordPage /> }],
  },
  {
    path: "/register",
    element: (
      <Suspense fallback={<FallbackLoader />}>
        <AuthLayout />
      </Suspense>
    ),
    children: [{ path: "/register", element: <RegisterPage /> }],
  },
];
